import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ModalImageCaptureComponent } from '../modal-image-capture/modal-image-capture.component';
import { ModalQrUploadMobileComponent } from '../modal-qr-upload-mobile/modal-qr-upload-mobile.component';
import { Router } from '@angular/router';

export interface IDialogModalIbputImageUploadData {
  idTrade: string;
  model?: string;
  evidences?: any;
  laudo?: any;
  smartUp?: boolean;
  token?: string;
  interfaceUi?: 'v1' | 'v2';
  questionKey?: string;
  productDivergenceEvidence?: boolean;
  question?: { text: string; answer: string; reason: string };
  questionOrder?: string | number;
}

@Component({
  selector: 'app-modal-input-image-upload',
  templateUrl: './modal-input-image-upload.component.html',
  styleUrls: ['./modal-input-image-upload.component.sass'],
})
export class ModalInputImageUploadComponent {
  mobileUploadOpened = false;
  constructor(
    private dialogRef: MatDialogRef<ModalInputImageUploadComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IDialogModalIbputImageUploadData,
    private _dialog: MatDialog,
    private router: Router
  ) {}

  onFileChanged(event: Event) {
    const target = event.target as HTMLInputElement;
    const file = target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.dialogRef.close(reader.result);
      };
    }
  }

  modalQrUploadMobile() {
    this.mobileUploadOpened = true;
    const { idTrade, model, evidences, token, smartUp, interfaceUi, question, questionOrder } =
      this.data;
    const commonData = {
      idTrade,
      model,
      evidences,
      laudo: !smartUp,
      token: token || '',
      interfaceUi,
      questionOrder,
      question,
      ...(this.data.productDivergenceEvidence ? { productDivergenceEvidence: true } : {}),
    };

    this._dialog.open(ModalQrUploadMobileComponent, {
      panelClass: 'custom-dialog-container',
      data: commonData,
    });
  }

  openDialog() {
    const dialogRef = this._dialog.open(ModalImageCaptureComponent, {
      panelClass: 'custom-dialog-container',
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.dialogRef.close(result);
      }
    });
  }

  onClose() {
    this.dialogRef.close();
  }
}
